import {
  Checkbox as AntCheckbox,
  CheckboxProps as AntCheckboxProps,
  ConfigProvider,
  theme,
} from 'antd';

export interface CheckboxProps extends AntCheckboxProps {
  /** Checkbox size (currently only M supported as per Figma) */
  size?: 'm';
}

/**
 * Checkbox component based on Figma Design System
 *
 * Uses Ant Design's ConfigProvider for consistent styling without
 * interfering with Ant Design's CSS-in-JS.
 *
 * @example
 * ```tsx
 * import { Checkbox } from '@libertify/ui';
 *
 * <Checkbox>Accept terms</Checkbox>
 * <Checkbox defaultChecked>Remember me</Checkbox>
 * <Checkbox disabled>Unavailable option</Checkbox>
 * ```
 */
export const Checkbox = ({
  size: _size = 'm',
  children,
  ...props
}: CheckboxProps) => {
  const { token } = theme.useToken();

  return (
    <ConfigProvider
      theme={{
        components: {
          Checkbox: {
            colorPrimary: token.colorPrimary,
            colorPrimaryHover: token.colorPrimaryHover,
            colorBorder: token.colorTextTertiary,
            borderRadiusSM: token.borderRadiusSM,
            controlInteractiveSize: 16,
          },
        },
      }}
    >
      <AntCheckbox {...props}>{children}</AntCheckbox>
    </ConfigProvider>
  );
};

export default Checkbox;
